<template>
	<div class="app-container">
		<div class="top_item">
			<div class="add_cate" @click="addAccount">添加分销渠道</div>
			<div class="search_rest search" @click="resetAccount">重置</div>
			<div class="search" @click="callAccount">查询</div>
			<el-input
				placeholder="输入主渠道名称搜索"
				size="mini"
				v-model="form.access_name"
				style="float: right; width: 160px; margin-right: 4px; margin-top: -18px"
			></el-input>
			<span
				style="float: right; margin-top: -18px; margin-right: 4px; color: #666"
				>渠道名称</span
			>
			<el-form
				:inline="true"
				ref="filtrateForm"
				size="mini"
				style="float: right; margin-top: 0px; margin-right: 4px; color: #666"
			>
				<el-form-item>
					<el-row>
						<el-col :span="18">
							<el-date-picker
								v-model="selectedTime"
								type="daterange"
								align="right"
								unlink-panels
								format="yyyy-MM-dd"
								range-separator="~"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								:default-time="['00:00:00', '23:59:59']"
								:picker-options="timeOptions"
							></el-date-picker>
						</el-col>
					</el-row>
				</el-form-item>
			</el-form>
			<span
				style="float: right; margin-top: -18px; margin-right: 4px; color: #666"
				>创建时间</span
			>
		</div>

		<el-table
			:data="tableData"
			border
			max-height="600"
			size="mini"
			style="width: 100%"
			:cell-style="tc"
			:header-cell-style="tc"
			@selection-change="handleSelectionChange"
			v-loading="listLoading"
		>
			<el-table-column label="渠道ID" prop="app_id"></el-table-column>
			<el-table-column label="渠道名称" prop="access_name"></el-table-column>
			<el-table-column label="联系人" prop="contact_name"></el-table-column>
			<el-table-column label="预充值账户余额" prop="balance"></el-table-column>
			<el-table-column label="渠道创建时间" prop="created_at"></el-table-column>
			<el-table-column label="接口开关">
				<template slot-scope="scope">
					<div>
						<el-switch
							:key="scope.row.app_id"
							:active-value="1"
							:inactive-value="0"
							:value="scope.row.interface_switch"
							@change="switchChange(scope.row.app_id, $event)"
						>
						</el-switch>
					</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" fixed="right" width="520">
				<template slot-scope="scope">
					<el-button size="mini" @click="setApply(scope.row.app_id)"
						>设置加润</el-button
					>
					<el-button
						size="mini"
						type="info"
						v-if="scope.row.status == 1"
						@click="disabledAccount(scope.row.app_id, 0)"
						>禁用</el-button
					>
					<el-button
						size="mini"
						type="success"
						v-else
						@click="disabledAccount(scope.row.app_id, 1)"
						>启用</el-button
					>
					<el-button size="mini" type="warning" @click="editAccount(scope.row)"
						>编辑</el-button
					>

					<el-button
						size="mini"
						type="danger"
						@click="chargeFn(scope.row.app_id)"
						>充值</el-button
					>
					<el-button
						size="mini"
						type="warning"
						@click="resetpassword(scope.row.app_id)"
						>修改密码</el-button
					>
					<el-button
						size="mini"
						type="danger"
						@click="clearToken(scope.row.app_id)"
						>清除token</el-button
					>
				</template>
			</el-table-column>
		</el-table>

		<el-row v-show="total > 0">
			<!-- <el-col :span="8"
        style="padding:12px 0;">
        <el-button :disabled="selectedList.length === 0"
          type="success"
          size="small"
          @click="batchToDelete">批量删除</el-button>
        <el-button :disabled="selectedList.length === 0"
          type="danger"
          size="small"
          @click="disableAllSelect">批量禁用</el-button>
      </el-col> -->
			<el-col :span="20">
				<div class="pagination">
					<el-pagination
						background
						@size-change="handleSizeChange"
						@current-change="pageChange"
						:current-page="form.page"
						:page-sizes="[20, 50, 100]"
						:page-size="form.page_size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					>
					</el-pagination>
				</div>
			</el-col>
		</el-row>

		<gydialog :title="title" :visible.sync="showAddOrEdit" width="540px;">
			<div style="padding: 20px 30px">
				<table class="accountinfo" border="1">
					<tr>
						<td class="left_account">
							<div>联系人姓名</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.contact_name"
								placeholder="请输入联系人姓名"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>接入商名称</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.access_name"
								placeholder="请输入接入商名称"
							></el-input>
						</td>
					</tr>

					<tr>
						<td class="left_account">
							<div>登陆账号</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.account"
								placeholder="请输入登陆账号"
							></el-input>
						</td>
					</tr>
					<tr v-if="title == '添加分销渠道'">
						<td class="left_account">
							<div>登陆密码</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.password"
								placeholder="请设置登陆密码"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>接口调用次数限制</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.call_limit"
								placeholder="请输入接口调用次数限制"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>IP白名单</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.ip_white_list"
								placeholder="请输入IP白名单"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>备注</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.remark"
								placeholder="请输入备注"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>联系人手机号</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.contact_mobile"
								placeholder="请输入联系人手机号"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>变动通知url</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="editForm.notice_url"
								placeholder="请输入变动通知url"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>是否开票</div>
						</td>
						<td style="text-align: left;padding-left: 24px;">
							<template>
								<el-radio
									style="width: 40px;"
									v-model="editForm.goods_price_set"
									:label="1"
									:disabled="!flag"
									>开票</el-radio
								>
								<el-radio
									style="width: 40px;"
									v-model="editForm.goods_price_set"
									:label="2"
									:disabled="!flag"
									>不开票</el-radio
								>
							</template>
						</td>
					</tr>
				</table>

				<div style="text-align: center; padding: 20px">
					<el-button size="mini" @click="cancelShowAccount">取消</el-button>
					<el-button size="mini" type="warning" @click="addEditAccount"
						>确定</el-button
					>
				</div>
			</div>
		</gydialog>
		<gydialog title="修改密码" :visible.sync="showPassword" width="540px;">
			<div style="padding: 20px 30px">
				<table class="accountinfo" border="1">
					<tr>
						<td class="left_account">
							<div>输入新密码</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="nwePassword"
								placeholder="请输入新密码"
							></el-input>
						</td>
					</tr>
				</table>

				<div style="text-align: center; padding: 20px">
					<el-button size="mini" @click="cancelShowPass">取消</el-button>
					<el-button size="mini" type="warning" @click="initAccountPasswordData"
						>确定</el-button
					>
				</div>
			</div>
		</gydialog>
		<gydialog title="修改密码" :visible.sync="showProfit" width="540px;">
			<div style="padding: 20px 30px">
				<table class="accountinfo" border="1">
					<tr>
						<td class="left_account">
							<div>输入加润比</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="profit"
								placeholder="请输入加润比"
							></el-input>
						</td>
					</tr>
				</table>

				<div style="text-align: center; padding: 20px">
					<el-button size="mini" @click="cancelShowProfit">取消</el-button>
					<el-button size="mini" type="warning" @click="sureProfit"
						>确定</el-button
					>
				</div>
			</div>
		</gydialog>
		<gydialog title="充值" :visible.sync="showCharge" width="540px;">
			<div style="padding: 20px 30px">
				<table class="accountinfo" border="1">
					<tr>
						<td class="left_account">
							<div>输入充值金额</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="chargeMoney"
								placeholder="请输入充值金额"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<div>备注</div>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="chargeRemark"
								placeholder="请输入备注"
							></el-input>
						</td>
					</tr>
					<tr>
						<td class="left_account">
							<el-button size="mini" @click="getCodeFn">获取验证码</el-button>
						</td>
						<td>
							<el-input
								size="mini"
								style="width: 240px; float: left; margin-left: 24px"
								v-model="code"
								placeholder="请输入验证码"
							></el-input>
						</td>
					</tr>
				</table>

				<div style="text-align: center; padding: 20px">
					<el-button size="mini" @click="cancelShowCharge">取消</el-button>
					<el-button size="mini" type="warning" @click="sureCharge"
						>确定</el-button
					>
				</div>
			</div>
		</gydialog>
	</div>
</template>

<script>
import {
	sysAccountList,
	upSwitch,
	sysCreateAccount,
	batchUpdateStatus,
	passwordupdate,
	getCode,
	chargeMoneyData,
	addProfitData,
	cleanTokenData
} from '@/api/channel'
import { parseTime } from '@/utils/index'
export default {
	data() {
		return {
			title: '添加分销渠道',
			flag: true,
			tableData: [],
			total: 0,
			listLoading: false,
			selectedList: [],
			form: {
				page_size: 20,
				page: 1,
				access_name: '',
				created_at_gt: '',
				created_at_lt: ''
			},
			selectedTime: '',
			timeOptions: {
				shortcuts: [
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近15天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(new Date().setMonth(new Date().getMonth() - 1))
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			showAddOrEdit: false,
			editForm: {
				app_id: '',
				contact_name: '',
				access_name: '',
				account: '',
				password: '',
				call_limit: '',
				ip_white_list: '',
				remark: '',
				contact_mobile: '',
				notice_url: '',
				goods_price_set: 0
			},
			showPassword: false,
			nwePassword: '',
			passId: '',
			showCharge: false,
			chargeMoney: '',
			chargeRemark: '',
			code: '',
			chargeId: '',
			showProfit: false,
			profit: '',
			profitId: ''
		}
	},
	activated() {
		this.listLoading = true
		this.sysAccountListData()
	},
	methods: {
		//添加分销渠道
		addAccount() {
			this.title = '添加分销渠道'
			this.showAddOrEdit = true
			this.flag = true
			this.editForm = {
				app_id: '',
				contact_name: '',
				access_name: '',
				account: '',
				password: '',
				call_limit: '',
				ip_white_list: '',
				remark: '',
				contact_mobile: '',
				notice_url: '',
				goods_price_set: ''
			}
		},
		//编辑用户
		editAccount(row) {
			console.log(row.goods_price_set)
			this.title = '编辑分销渠道'
			this.showAddOrEdit = true
			this.flag = false
			this.editForm.app_id = row.app_id
			this.editForm.contact_name = row.contact_name
			this.editForm.access_name = row.access_name
			this.editForm.account = row.account
			this.editForm.call_limit = row.call_limit
			this.editForm.ip_white_list = row.ip_white_list
			this.editForm.remark = row.remark
			this.editForm.contact_mobile = row.contact_mobile
			this.editForm.notice_url = row.notice_url
			this.editForm.goods_price_set = row.goods_price_set
		},
		//重置
		resetAccount() {
			this.selectedTime = ''
			this.form = {
				access_name: '',
				created_at_gt: '',
				created_at_lt: ''
			}
		},
		//查询
		callAccount() {
			this.form.page = 1
			this.getList()
		},
		handleSizeChange(val) {
			this.form.size = val
			this.pageChange(1)
		},
		pageChange(page) {
			this.form.page = page
			this.getList()
		},
		// batchToDelete () {
		//   this.$confirm('确定删除账户?', '提示', {
		//     confirmButtonText: '确定',
		//     cancelButtonText: '取消',
		//     type: 'warning'
		//   })
		//     .then(() => {
		//       const selectedList = this.selectedList
		//       if (selectedList.length > 0) {
		//         const arr = []
		//         selectedList.forEach(item => {
		//           arr.push(item.app_id)
		//         })
		//         this.batchDeleteData(arr.join('|'))
		//       }
		//     })
		//     .catch(() => {
		//       console.log('cancel')
		//     })
		// },
		// disableAllSelect () {
		//   this.$confirm('确定禁用账户?', '提示', {
		//     confirmButtonText: '确定',
		//     cancelButtonText: '取消',
		//     type: 'warning'
		//   }).then(() => {
		//     const selectedList = this.selectedList
		//     if (selectedList.length > 0) {
		//       const arr = []
		//       selectedList.forEach(item => {
		//         arr.push(item.app_id)
		//       })
		//       this.batchUpdateStatusData(arr.join('|'), 1)
		//     }
		//   })
		// },
		async getList() {
			const form = this.form
			if (this.selectedTime !== '') {
				form.created_at_gt = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.created_at_lt = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			}
			let res = await sysAccountList(this.form)
			this.listLoading = false
			this.tableData = res.data
			this.total = res.total
		},
		cancelShowAccount() {
			this.showAddOrEdit = false
			this.editForm = {
				app_id: '',
				contact_name: '',
				access_name: '',
				account: '',
				password: '',
				call_limit: '',
				ip_white_list: '',
				remark: '',
				contact_mobile: '',
				notice_url: '',
				goods_price_set: ''
			}
		},
		addEditAccount() {
			if (!this.editForm.contact_name) {
				this.$message.error('联系人姓名不能为空')
				return
			}

			if (!this.editForm.access_name) {
				this.$message.error('接入商名称不能为空')
				return
			}
			if (!this.editForm.account) {
				this.$message.error('登陆账号不能为空')
				return
			}

			if (!this.editForm.call_limit) {
				this.$message.error('接口调用次数限制不能为空')
				return
			}
			if (!this.editForm.ip_white_list) {
				this.$message.error('IP白名单不能为空')
				return
			}

			if (!this.editForm.remark) {
				this.$message.error('备注不能为空')
				return
			}
			if (!this.editForm.contact_mobile) {
				this.$message.error('联系人手机号不能为空')
				return
			}

			if (!this.editForm.notice_url) {
				this.$message.error('变动通知url不能为空')
				return
			}

			if (!this.editForm.goods_price_set && this.flag) {
				this.$message.error('请选择是否开票')
				return
			}

			if (this.title == '添加分销渠道') {
				if (this.editForm.password.length < 6) {
					this.$message.error('密码位数不能小于6位')
					return
				}
				this.sysCreateAccountData()
			} else {
				this.updateAccountInfoData()
			}
		},
		//获取列表
		async sysAccountListData() {
			let res = await sysAccountList(this.form)
			this.listLoading = false
			this.tableData = res.data
			this.total = res.total
		},
		//添加新账户
		async sysCreateAccountData() {
			let res = await sysCreateAccount(this.editForm)
			console.log(res)
			this.$message.success('创建账号成功')
			this.cancelShowAccount()
			this.pageChange(1)
		},

		//更新用户信息
		async updateAccountInfoData() {
			let res = await sysCreateAccount(this.editForm)
			console.log(res)
			this.$message.success('更新信息成功')
			this.cancelShowAccount()
			this.pageChange(1)
		},
		//禁用账户
		disabledAccount(app_id, type) {
			this.batchUpdateStatusData(app_id, type)
		},
		async batchUpdateStatusData(app_id, type) {
			var form = {
				app_id: app_id,
				status: type
			}
			let res = await batchUpdateStatus(form)
			console.log(res)
			this.$message.success('操作成功')
			this.getList()
		},
		cancelShowPass() {
			this.showPassword = false
			this.passId = ''
		},
		//重置密码
		resetpassword(app_id) {
			this.showPassword = true
			this.passId = app_id
		},
		async initAccountPasswordData() {
			let res = await passwordupdate({
				app_id: this.passId,
				password: this.nwePassword
			})
			console.log(res)
			this.$message.success('密码修改成功')
			this.cancelShowPass()
			this.pageChange(1)
		},
		// 清除token
		clearToken(app_id) {
			this.$confirm('确定清除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.cleanTokenAsync(app_id)
				})
				.catch(error => {
					console.log(error)
				})
		},
		async cleanTokenAsync(app_id) {
			let res = await cleanTokenData({
				app_id
			})
			console.log(res)
			this.$message.success('清除成功')
			this.pageChange(1)
		},
		// 开关
		switchChange(id, e) {
			if (e == 1) {
				//开
				this.updateRecommendData({ app_id: id, interface_switch: 1 })
			} else {
				//关
				this.updateRecommendData({ app_id: id, interface_switch: 0 })
			}
		},
		//更改开关
		async updateRecommendData(data) {
			upSwitch(data).then(() => {
				this.$message.success('操作成功')
				this.getList()
			})
		},
		// 设置加润
		cancelShowProfit() {
			this.showProfit = false
			this.profitId = ''
		},
		setApply(app_id) {
			this.showProfit = true
			this.profitId = app_id
		},
		async sureProfit() {
			let res = await addProfitData({
				app_id: this.profitId,
				add_profit: this.profit
			})
			console.log(res)
			this.$message.success('设置成功')
			this.cancelShowProfit()
			this.pageChange(1)
		},
		//充值
		async getCodeFn() {
			if (!this.chargeMoney) {
				this.$message.error('输入充值金额')
				return
			}
			let res = await getCode({
				app_id: this.chargeId,
				money: this.chargeMoney
			})
			console.log(res)
			this.$message.success('发送成功')
		},
		cancelShowCharge() {
			this.showCharge = false
			this.chargeId = ''
		},
		chargeFn(app_id) {
			this.showCharge = true
			this.chargeId = app_id
		},
		async sureCharge() {
			if (!this.chargeMoney) {
				this.$message.error('输入充值金额')
				return
			}
			if (!this.chargeRemark) {
				this.$message.error('输入充值备注')
				return
			}
			if (!this.code) {
				this.$message.error('输入验证码')
				return
			}
			let res = await chargeMoneyData({
				app_id: this.chargeId,
				money: this.chargeMoney,
				remark: this.chargeRemark,
				code: this.code
			})
			console.log(res)
			this.$message.success('充值成功')
			this.cancelShowCharge()
			this.pageChange(1)
		},
		tc() {
			return 'text-align:center;'
		},
		handleSelectionChange(arr) {
			this.selectedList = arr
		}
	}
}
</script>

<style lang="scss" scoped>
.app-container {
	padding: 20px;
	background-color: #fff;
}
.top_item {
	background-color: #fff;
	border-radius: 4px;
	height: 64px;
	line-height: 64px;
}
.add_cate {
	float: left;
	width: 100px;
	height: 30px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 30px;
	border-radius: 4px;
	cursor: pointer;
}

.search {
	float: right;
	width: 64px;
	margin-left: 6px;
	height: 28px;
	color: #fff;
	background-color: rgb(254, 153, 39);
	font-size: 14px;
	text-align: center;
	line-height: 28px;
	border-radius: 4px;
	cursor: pointer;
}
.search_export {
	background-color: #3498d8;
}
.search_rest {
	background-color: #67c23a;
}
.account_status_start {
	color: #67c23a;
	float: left;
	width: 4px;
	padding-left: 16px;
	text-align: center;
	border-radius: 50%;
}
.account_status_end {
	color: #f4222d;
	float: left;
	width: 4px;
	padding-left: 16px;
	text-align: center;
	border-radius: 50%;
}
.accountinfo {
	border-width: 1px;
	border-color: rgb(228, 228, 228);
	border-collapse: collapse;
	width: 100%;
	tr {
		height: 40px;
	}
}
.left_account {
	background-color: rgb(249, 250, 252);
	color: #333;
	font-size: 14px;
}
</style>
